import React, { useEffect, useState } from 'react';
import Tippy from '@tippyjs/react';
import { sticky } from 'tippy.js';
import { Button } from '../Button';
import styles from './Tooltip.module.scss';
export const Tooltip = ({ tooltip, handleDismiss, parentRef, placement, delay = 1000, }) => {
    const [showDelayed, setShowDelayed] = useState(false);
    useEffect(() => {
        setTimeout(() => {
            setShowDelayed(true);
        }, delay);
    }, [delay]);
    const onTooltipClose = (forever) => {
        handleDismiss(tooltip.id, forever);
    };
    return (<Tippy content={<div className={styles.tooltipContainer}>
          <img className={styles.closeIcon} src='https://www.haven.com/assets/owners/shared/close_white.svg' alt='close' role='presentation' onClick={() => onTooltipClose(false)}/>
          <div className={styles.tooltipBody} dangerouslySetInnerHTML={{
                __html: tooltip.text,
            }}/>
          <Button onClick={() => onTooltipClose(true)}>Ok, got it!</Button>
        </div>} placement={placement} reference={parentRef} interactive visible={showDelayed} duration={600} sticky={true} plugins={[sticky]}/>);
};
